import * as fetcher from "../helpers/fetcher";

export async function login(email, password) {
  return fetcher.post(`/auth/login`, {}, { email: email, password: password });
}

export async function guestLogin() {
  return fetcher.post(`/auth/register-guest`, {}, {});
}

export async function register(firstName, lastName, email, password, phone) {
  return fetcher.post(
    `/auth/register`,
    {},
    { firstName, lastName, email, password, phone }
  );
}

export async function requestResetPassword(email) {
  return fetcher.post(`/auth/request-reset-password`, {}, { email });
}

export async function resetPassword(token, newPassword) {
  return fetcher.post(`/auth/reset-password`, {}, { token, newPassword });
}
